import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Slider } from '@/components/ui/slider';
import { useFilters } from '@/context/filters-context';
import React from 'react';

export const PriceFilter = () => {
    const { filters, setFilters } = useFilters();
    const [min, max] = filters.priceRange;

    const handleRangeChange = (value: number[]) => {
        setFilters((prev) => ({
            ...prev,
            priceRange: [value[0], value[1]],
        }));
    };

    const handleMinChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newMin = Number(e.target.value);
        if (!isNaN(newMin) && newMin <= max) {
            setFilters((prev) => ({
                ...prev,
                priceRange: [newMin, prev.priceRange[1]],
            }));
        }
    };

    const handleMaxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newMax = Number(e.target.value);
        if (!isNaN(newMax) && newMax >= min) {
            setFilters((prev) => ({
                ...prev,
                priceRange: [prev.priceRange[0], newMax],
            }));
        }
    };

    return (
        <div className="space-y-4">
            <div className="flex justify-between">
                <Label className="font-medium">Price Range</Label>
                <div className="text-sm text-muted-foreground">
                    ${min} - ${max}
                </div>
            </div>

            <Slider
                min={0}
                max={1000}
                step={50}
                value={[min, max]}
                onValueChange={handleRangeChange}
                className="py-4"
            />

            <div className="flex gap-3">
                <div>
                    <Label htmlFor="min-price" className="text-xs">
                        Min
                    </Label>
                    <Input
                        id="min-price"
                        type="number"
                        value={min}
                        onChange={handleMinChange}
                        className="h-8 w-24"
                    />
                </div>

                <div>
                    <Label htmlFor="max-price" className="text-xs">
                        Max
                    </Label>
                    <Input
                        id="max-price"
                        type="number"
                        value={max}
                        onChange={handleMaxChange}
                        className="h-8 w-24"
                    />
                </div>
            </div>
        </div>
    );
};
